import { Schema } from '../schemas';
import { InvalidContextError } from '../errors';
import BaseComponent from './BaseComponent';
import { getAppExtensionData } from '../../utils/mainConfig';

class RootComponent extends BaseComponent {
  constructor(context = {}) {
    const appExtensionData = getAppExtensionData();
    if (
      !context.appId ||
      !(appExtensionData.appIds || []).includes(context.appId)
    ) {
      throw new InvalidContextError();
    }

    super(document.body, Schema.Root(), context);
  }

  exist() {
    return !!this._node;
  }
}

export default RootComponent;
